// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sjBw","right":"styles_right__2iG-5"};